/**
 * Firebase Cloud Messaging (FCM) — Firebase JS SDK v8 compat API.
 * Config: src/firebase-config.js (keep public/firebase-messaging-sw.js in sync).
 */
import firebase from 'firebase/app'
import 'firebase/messaging'
import { firebaseConfig, FCM_VAPID_KEY } from './firebase-config'

export { firebaseConfig } from './firebase-config'

let messaging = null

if (typeof window !== 'undefined') {
  try {
    if (!firebase.apps.length) {
      firebase.initializeApp(firebaseConfig)
    }
    if (typeof firebase.messaging.isSupported === 'function' && firebase.messaging.isSupported()) {
      messaging = firebase.messaging()
      if (FCM_VAPID_KEY && typeof messaging.usePublicVapidKey === 'function') {
        messaging.usePublicVapidKey(FCM_VAPID_KEY)
      }
    } else {
      console.warn('[fcm] Firebase Cloud Messaging is not supported in this browser.')
    }
  } catch (err) {
    // Messaging unsupported (e.g. non-secure context) — callers must tolerate null.
    console.warn('[fcm] Firebase messaging init skipped:', err && err.message ? err.message : err)
  }
}

export default messaging
export { firebase }
